module.exports = __webpack_public_path__ + "img/try4.9dca9df3.png";